export enum BucketName {
    OrderHistory = 1,
    HubMenu
}
